(function fullImageViewerSetters(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  const previousFullImageViewerSetters = global.NewHomeSource.FullImageViewerSetters;

  /**
   * @private
   * compareById: true if the currentImage.Id is equals to the id, otherwise false.
   *
   * @param {object} currentImage that is being evaluated
   * @param {*} id of the image.
   */
  function compareById(currentImage, id) {
    return currentImage.Id === id;
  }

  /**
   * @private
   * setImageFromUrl: sets the information regarding the selected image using the given URL.
   *
   * @param {object} element that will be used to decide if the image is selected.
   * @param {function} fn function that returns the value for the isSelected property.
   * @param {boolean} flag value to be passed to the fn parameter.
   */
  function setImageFromCondition(element, fn, data, flag) {
    const collectionKeys = Object.keys(data);
    const collectionKeysLength = collectionKeys.length;
    let selectedImage = null;

    for (let index = 0; index < collectionKeysLength; index += 1) {
      const currentCollection = data[collectionKeys[index]];
      const collectionImages = currentCollection.Images;

      if (currentCollection.Images) {
        const imageKeys = Object.keys(collectionImages);
        const imageKeysLength = imageKeys.length;

        for (let current = 0; current < imageKeysLength; current += 1) {
          const currentImage = collectionImages[imageKeys[current]];

          currentImage.IsSelected = fn(currentImage, element, flag);

          if (currentImage.IsSelected) {
            selectedImage = Object.assign(currentImage);
          }
        }

        currentCollection.IsSelected = selectedImage && selectedImage.Collection === currentCollection.Name;
      }
    }

    return selectedImage;
  }

  /**
   * @private
   * setImage: sets the selected image according to the image tag provided as parameter.
   *
   * @param {object} image where the information related to the state exists.
   * @param {object} data with the information about the Full Image Viewer State.
   */
  function setImageFromImageTag(image, data) {
    const activeImage = global.document.querySelector('[data-full-image-viewer-opener="true"].active') || image;
    let selectedImage = null;
    const collection = data[activeImage.dataset.collection];
    const currentImage = collection.Images['Image' + activeImage.dataset.imageId];
    collection.IsSelected = true;
    currentImage.IsSelected = true;
    selectedImage = Object.assign(currentImage);
    return selectedImage;
  }

  /**
   * @private
   * setImage: sets the selected image according to the button tag provided as parameter.
   *
   * @param {object} image where the information related to the state exists.
   * @param {object} data with the information about the Full Image Viewer State.
   */
  function setImageFromButtonTag(button, data) {
    const collectionKeys = Object.keys(data);
    const collectionKeysLength = collectionKeys.length;
    const selectedCollection = button.getAttribute('data-type') || collectionKeys[0];
    let selectedImage = button.getAttribute('data-type') || null;
    const collection = data[selectedCollection];
    const imageId = button.dataset.imageId;
    let image;

    if (imageId) {
      image = collection.Images['Image' + button.dataset.imageId];
    }

    for (let index = 0; index < collectionKeysLength; index += 1) {
      const currentCollection = data[collectionKeys[index]];

      if (typeof currentCollection === 'object') {
        currentCollection.IsSelected = selectedCollection === currentCollection.Name;
      }
    }

    const collectionImages = data[selectedCollection].Images;
    const imageKeys = Object.keys(collectionImages);
    const imageKeysLength = imageKeys.length;

    if (image) {
      selectedImage = image;
      selectedImage.IsSelected = true;
    } else {
      for (let current = 0; current < imageKeysLength; current += 1) {
        const currentImage = collectionImages[imageKeys[current]];

        currentImage.IsSelected = current === 0;

        if (currentImage.IsSelected) {
          selectedImage = Object.assign({ }, currentImage);
        }
      }
    }

    return selectedImage;
  }

  /**
   * @private
   * setImageFromObject: set the selected image according to the object provided as parameter.
   *
   * @param {object} image with the information that is going to be set in the state.
   * @param {object} data with the information about the Full Image Viewer State.
   */
  function setImageFromObject(image, data) {
    return setImageFromCondition(image.Id, compareById, data);
  }

  /**
  * @private
  * Different ways to set the fullImageViewerState
  */
  const setters = {
    A: setImageFromButtonTag,
    DIV: setImageFromButtonTag,
    IMG: setImageFromImageTag,
    BUTTON: setImageFromButtonTag,
    PICTURE: setImageFromImageTag,
    object: setImageFromObject,
  };

  /**
   * @constructs NewHomeSource.FullImageViewerSetters
   */
  function FullImageViewerSetters() {
  }

  /**
   * @public
   * getImage: gets the image that is related to the opener.
   *
   * @param {any} opener element or object that will be used to search for the more accurate image.
   * @param {object} data with the information about the Full Image Viewer State.
   */
  FullImageViewerSetters.getImage = function getImage(opener, data) {
    const setFunction = setters[opener.tagName || typeof opener];

    if (setFunction) {
      return setFunction(opener, data);
    }

    return null;
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.FullImageViewerSetters to the previous script.
   */
  FullImageViewerSetters.noConflict = function noConflict() {
    global.NewHomeSource.FullImageViewerSetters = previousFullImageViewerSetters;
    return FullImageViewerSetters;
  };

  global.NewHomeSource.FullImageViewerSetters = FullImageViewerSetters;
}(window));
